import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import Loader from 'components/Loader';
import { isValidToken } from 'utils';

const Private = () => {
	const isAuth = isValidToken();
	const location = useLocation();

	return isAuth ? (
		<Suspense fallback={<Loader />}>
			<Outlet />
		</Suspense>
	) : (
		<Navigate to="/login" state={{ previousLocation: location.pathname }} />
	);
};

export default Private;
